const Footer = () => (
  <footer className="border-t border-lt-border px-8 py-10 text-center transition-colors">
    <div className="mb-3 font-serif text-lg font-semibold text-foreground">
      Loto<em className="text-primary italic">Terminal</em>
    </div>
    <p className="mx-auto max-w-[600px] text-xs leading-relaxed text-lt-cream3">
      Site exclusivamente educativo e informativo. Não realizamos apostas nem vendas de bilhetes. Jogos de loteria
      envolvem probabilidades matemáticas fixas — nenhuma estratégia altera as chances reais de ganhar.
      <br />
      © 2026 LotoTerminal · Todos os direitos reservados
    </p>
  </footer>
);

export default Footer;
